import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Button } from 'antd'

const BrowserModal = (props: any) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const explorer = window.navigator.userAgent
    if (explorer.indexOf('Chrome') === -1) {
      setVisible(true)
    }
  }, [])

  const onCancel = useCallback(() => {
    setVisible(false)
  }, [])

  return (
    <Modal
      title="您的浏览器不支持"
      visible={visible}
      footer={null}
      closable={false}
      maskClosable={false}
      width={460}
      onCancel={onCancel}
    >
      <div className="star-browser-modal star-base-modal">
        <div className="modal-text">您的浏览器在使用产品中可能会出现未知的问题，建议使用Chrome浏览器，Chrome浏览器<a href="https://www.google.com/intl/zh-CN/chrome/" target="_blank">下载地址</a></div>
        <div className="btn-area">
          <Button type="primary" onClick={onCancel}>确认</Button>
        </div>
      </div>
    </Modal>
  )
}


export default React.memo(BrowserModal);